import { CardCvcElement } from '@stripe/react-stripe-js';
import { StripeCardCvcElementChangeEvent, StripeCardCvcElementOptions } from '@stripe/stripe-js';
import React, { FC, memo, useState } from 'react';
import { getCardFieldOptions } from '../../constants';
import ErrorMessage from '../errorMessage';
import s from './index.module.scss';
import classnames from 'classnames';
import locales from '../../../../../../../../../../content.json';

type Props = {
  className?: string;
  options?: StripeCardCvcElementOptions;
  onChange?: (event: StripeCardCvcElementChangeEvent) => void;
};

const CardCvc: FC<Props> = props => {
  const { className, onChange, options = getCardFieldOptions() } = props;
  const [empty, setEmpty] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();
  const [isFieldEmpty, setIsFieldEmpty] = useState<boolean>(true);

  const handleChange = (event: StripeCardCvcElementChangeEvent) => {
    setError(event.error?.message);
    setIsFieldEmpty(event.empty);
    onChange && onChange(event);
  };

  const handleFocus = () => {
    setEmpty(true);
  };

  const handleBlur = () => {
    setEmpty(!isFieldEmpty);
  };

  return (
    <>
      <div className={classnames(className, s.cvc, { [s.empty]: empty })}>
        <CardCvcElement 
          onChange={handleChange} 
          onFocus={handleFocus} 
          onBlur={handleBlur} 
          options={options} 
        />
        {/* <img data-test="card-brand" className={s.cvc__img} src={cvc} alt="cvc" /> */}
        {empty && (
          <span className={s.cvc_title}>{locales[window.userLang].payment_text_107}</span>
        )}
      </div>
      {/* {error && <ErrorMessage error={error} />} */}
      <ErrorMessage error={error} />
    </>
  );
};

export default memo(CardCvc);
